'use client';
import { useEffect } from 'react';
import { Box } from 'ui/components/box';

export default function PrivacyPage() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://app.termly.io/embed-policy.min.js';
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <>
      <Box
        css={{
          width: 'width.parent',
          maxWidth: ['maxWidth.bodyChild.mobile', 'maxWidth.bodyChild.sm'],
          paddingBottom: '10rem',
        }}
        data-id='682e9bd2-a378-480d-a87d-38110284925d'
        data-type='iframe'
        // @ts-ignore
        name='termly-embed'
      />
    </>
  );
}
